<h3 mat-dialog-title>Are you sure you want to delete all at once</h3>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button cdkFocusInitial color="primary" (click)="onSend()">
    Delete All
  </button>
</mat-dialog-actions>
